import type { Income } from '@/types/AddIncome'
import type {
  BenefitsIncome,
  EmploymentIncome,
  IncomeProperties,
  IndependentMeansIncome,
  PensionIncome,
  SelfEmploymentIncome,
  StudentIncome,
  ThirdPartyPayment,
} from '@/types/Income'

export function buildIncome(income: Income) {
  switch (income.type) {
    case 'regularIncome':
      switch (income.status) {
        case 'employment':
          const employment: EmploymentIncome = {
            type: 'employment',
            status: income.status,
            contractType: income.contractType,
            startDate: income.startDate,
            contractSchedule: income.contractSchedule,
            incomeProperties: buildIncomeProperties(income.incomeProperties),
            company: income.company,
            address: income.address,
            position: income.position,
            evidenceType: 'Upload Documents',
          }

          switch (income.contractType) {
            case 'temporary':
            case 'fixed-term':
              employment.endDate = income.endDate
              break
          }

          if (income.hasGuaranteedBonus) {
            employment.guaranteedBonus = buildIncomeProperties(income.bonus)
          }

          return employment
        case 'self-employed':
          const selfEmployment: SelfEmploymentIncome = {
            type: 'employment',
            status: income.status,
            startDate: income.startDate,
            incomeProperties: buildIncomeProperties(income.incomeProperties),
            evidenceType: 'Upload Documents',
          }
          return selfEmployment
        default:
          return {}
      }
    case 'independentMeans':
      switch (income.meansType) {
        case 'pension':
          const pension: PensionIncome = {
            type: income.meansType,
            provider: income.pensionsProvider,
            incomeProperties: buildIncomeProperties(income.incomeProperties),
            evidenceType: 'Upload Documents',
          }
          return pension
        default:
          const independentMeans: IndependentMeansIncome = {
            type: income.meansType,
            incomeProperties: buildIncomeProperties(income.incomeProperties),
            evidenceType: 'Upload Documents',
          }
          return independentMeans
      }
    case 'benefits':
      const benefits: BenefitsIncome = {
        type: 'benefits',
        incomeProperties: buildIncomeProperties(income.incomeProperties),
        evidenceType: 'Upload Documents',
      }
      return benefits
    case 'student':
      const student: StudentIncome = {
        type: 'student',
        incomeProperties: buildIncomeProperties(income.incomeProperties),
        evidenceType: 'Upload Documents',
        startDate: income.startDate,
        endDate: income.endDate,
        institution: income.institution,
        address: income.address,
        idNumber: income.idNumber,
      }
      return student
    case 'thirdParty':
      const thirdParty: ThirdPartyPayment = {
        type: 'third party',
        incomeProperties: buildIncomeProperties(income.incomeProperties),
        evidenceType: 'Upload Documents',
      }
      return thirdParty
    default:
      return {}
  }
}

function buildIncomeProperties(incomeProperties: IncomeProperties) {
  incomeProperties.currency = {
    code: 'GBP',
    name: 'British Pound Sterling',
    symbol: '£',
  }

  // eslint-disable-next-line eqeqeq
  if (incomeProperties.frequency != 'Hourly') {
    incomeProperties.averageHoursAWeek = null
  }

  return incomeProperties
}
